import posthog from 'posthog-js'

const FEATURE_FLAG_KEYS = [
  'product-hits-feature',
  'leaflet-geolocation-exclusions',
  'location-groups',
  'store-sales-models'
] as const

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number]

type FeatureFlagOptions = {
  send_event?: boolean
  fresh?: boolean
}

export function isFeatureEnabled(key: FeatureFlagKey, options?: FeatureFlagOptions): boolean {
  return !!posthog.isFeatureEnabled(key, options)
}

export function onFeatureFlagsReady(callback: Parameters<typeof posthog.onFeatureFlags>[0]): void {
  posthog.onFeatureFlags(callback)
}
